export function sanitizeSiteTitle(inputString: string): string {
    if (!inputString) return ''

    // Remove "${...}"
    const cleanedString = inputString.replace(/\$\{[^}]*\}/g, '')

    // Remove all special characters and surrounding spaces
    const sanitizedString = cleanedString.replace(/[^a-zA-Z0-9\s]/g, '').trim()

    return sanitizedString
}
